import React from "react";

const Card = ({ title, children }) => (
  <div className="container">
    <div className="row">
      <div>
        <div className="card">
          <div className="card-content">
            <span className="card-title center-align">{title}</span>
            {children}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Card;



// WEBPACK FOOTER //
// ./src/views/Card.js